import React, { useState, useEffect } from 'react';
import numeral from 'numeral';
import { Button } from "../../../../components/buttons";

const ServiceCard = props => {
    const [ open, setOpen ] = useState(false)
    const firstHalf = props.services.slice(0,6)
    const theRest = props.services.slice(7,100)
    return (
        <div className="card mb-4">
            <h5>{props.title}</h5>
            <h5 className="text-success">
                {props.price === 0 ? "Free" : `Rp ${numeral(props.price).format("0,0")}`}
            </h5>
            {
                firstHalf.map(i => (
                    <div className={`${i.includes("Semua") ? "text-success bold" : ""}`}>
                        {i}
                    </div>
                ))
            }
            {
                open ? theRest.map(i => (
                    <div>
                        {i}
                    </div>
                )) : null
            }
            {
                open ? 
                    <a className="text-danger pointer" onClick={() => setOpen(false)}><b>Tutup Kembali</b></a> :
                    <a className="text-primary pointer" onClick={() => setOpen(true)}><b>Klik untuk list lengkap</b></a>
            }
            
            <Button className="mt-2 btn btn-primary btn-block btn-sm" onClick={() => props.onClick(props.title)}>
                Aktifkan
            </Button>
        </div>
    )
}

export default ServiceCard;